import React from 'react'
import './styles.css'

const TourPaginado = ({ data, identificador, prev, next }) => {
    return (
        <div className='contain-paginado-tour'>
            {
                data.prev_page_url == null ?
                    ''
                    :
                    <button onClick={() => prev(data.prev_page_url, identificador)}>
                        anterior
                    </button>
            }

            <span>
                {
                    data.current_page
                }
            </span>
            {
                data.next_page_url == null ?
                    ''
                    :
                    <button onClick={() => next(data.next_page_url, identificador)}>
                        siguiente
                    </button>
            }

        </div>
    )
}

export default TourPaginado